import {
  CHANGE_CURRENT_ORGANIZATION_INDEX,
  FETCH_USER_GENERAL_INFO
} from '../constants/ActionTypes';
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from '../constants/PromiseMiddleware';

const defaultStore = {
  isFetching: false,
  processes: []
};

const processes = (state = defaultStore, action) => {
  switch (action.type) {
    case FETCH_USER_GENERAL_INFO:
      return { ...state };

    case FETCH_USER_GENERAL_INFO + _PENDING:
      return { ...state, isFetching: true };

    case FETCH_USER_GENERAL_INFO + _REJECTED:
      return { ...state, isFetching: false };

    case FETCH_USER_GENERAL_INFO + _FULFILLED:
      return {
        ...state,
        isFetching: false,
        processes: action.payload.data.result.processes
      };

    default:
      return state;
  }
};

module.exports = processes;



// WEBPACK FOOTER //
// ./reducers/processesReducer.js